import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { adminApi, setNoindex } from '../lib/adminApi';

const ProtectedAdminRoute = ({ children }) => {
  const [state, setState] = useState('checking'); // checking | authed | unauthed
  const [admin, setAdmin] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const undo = setNoindex();
    (async () => {
      try {
        const me = await adminApi.me();
        setAdmin(me);
        setState('authed');
      } catch (e) {
        setState('unauthed');
      }
    })();
    return undo;
  }, []);

  if (state === 'checking') {
    return (
      <div className="min-h-screen bg-[color:var(--ink)] flex items-center justify-center text-[color:var(--ivory)]">
        <div className="text-sm tracking-[0.3em] uppercase opacity-70">Loading…</div>
      </div>
    );
  }

  if (state === 'unauthed') {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  return typeof children === 'function' ? children({ admin }) : children;
};

export default ProtectedAdminRoute;
